module.exports = __webpack_public_path__ + "static/media/2022.7e050908.jpg";